import './date-element.scss';

export default {
  group: 'form-group',
  label: 'label-override',
  dateWrapper: 'input-group',
  date: 'form-control date-element',
  calendarIcon: 'glyphicon glyphicon-calendar',
  calendarButton: 'input-group-addon btn',
  calendarAnchor: 'anchor',
  calendarWrapper: 'calendar',
  requiredIndicator: 'required-indicator',
};
